import type { TileableModel } from '@rocco/ui/tile-shared/view-models/tile';
import type { TileMediaAspectRatio } from '@rocco/ui/tile-shared/components/TileMedia';
import { isArticleTileViewModel } from '@rocco/ui/tile-article/view-models/article';

/**
 * Aspect ratio for a search result tile.
 *
 * With the category revamp active, every vertical uses the portrait browse
 * card. Projects deliberately do NOT get their browse page's `projectBrowse`
 * card here: that card's footer is styled for the dark projects browse theme
 * (white title / white-40 professional), so on the white search page its text
 * is invisible. With the revamp off, everything keeps the pre-revamp default.
 *
 * Articles take the editorial card the `/articles` directory draws, which locks
 * its own 437x524 picture box and expects the media to fill it — `featured` is
 * the `h-full` answer. Asking for the article aspect inside that box would
 * leave a fifth of the frame empty under the photograph.
 */
export const getSearchTileAspect = (
    model: TileableModel,
    categoryRevampActive: boolean,
): TileMediaAspectRatio => {
    if (isArticleTileViewModel(model)) {
        return categoryRevampActive ? 'featured' : 'article';
    }
    return categoryRevampActive ? 'portrait' : 'default';
};
